import{createContext as o}from"react";var t=o({add:()=>0,addMany:()=>{},addError:()=>0,addInfo:()=>0,addSuccess:()=>0,addWarning:()=>0,clear:()=>{},clearAll:()=>{}});import{useContext as e}from"react";var i=()=>e(t);export{t as ToastsContext,i as useToasts};
//# sourceMappingURL=index.js.map
